import { useCallback } from "react";
import useGetWorkOrder from "../useGetWorkOrder";
import { useWorkOrderStore } from "../../store/wo-order";
import { getMeterReadings } from "../../api/MeterReadings";

export default function useGetMeterReadingHistory() {
  const { trigger } = useGetWorkOrder();
  const setMeterReadingHistory = useWorkOrderStore(
    (state) => state.setMeterReadingsHistory
  );

  const getMeterReadingHistory = useCallback(
    async (woNumber: string, meters: string) => {
      let currentWo = useWorkOrderStore.getState().getWorkOrderById(woNumber);
      if (!currentWo) {
        const response = await trigger(woNumber);
        if (response.status === 200) currentWo = response.data;
      }

      if (!currentWo?.Equipment) return; // unable to get the work order
      const equipSerialInd = currentWo.WriteWoToSerialFlag === true ? "s" : "e";
      const meterData = {
        equipSerialId: currentWo.Equipment,
        equipSerialInd,
        meters,
      };
      const response = await getMeterReadings(meterData);
      setMeterReadingHistory(meters, response.data);
      return response;
    },
    [setMeterReadingHistory, trigger]
  );

  return { getMeterReadingHistory };
}
